/* eslint-disable sort-keys */
export default {
  light: {
    "app-footer-background": "neutral-700",
    "dark-mode-toggle-bar-bg": "neutral-200",
    "dark-mode-toggle-bar-fg": "neutral-900",
    "dark-mode-toggle-icon-fg": "neutral-900",
    "search-results-background": "neutral-900",
    "search-results-watermark": "neutral-200",
    "service-error-message-border": "primary-100",
    // skip to content link
    "skip-to-content": "primary-500",
    "skip-to-content-light": "neutral-900",
  },
  dark: {
    // skip to content link
    "skip-to-content": "primary-900",
  },
};
